<template>
  <AppLayout>
    <router-view />
  </AppLayout>
</template>